/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSparkWalletBalanceRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetSparkWalletBalanceResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getSparkWalletBalance = (request: GetSparkWalletBalanceRequest, options?: CashRequestOptions) => post<GetSparkWalletBalanceRequest, GetSparkWalletBalanceResponse>("/2.0/cash/get-spark-wallet-balance", request, {...options, rejectOnError: true })